import { render } from "./order-collection.vue?vue&type=template&id=3d6cc6cb&scoped=true"
import script from "./order-collection.vue?vue&type=script&lang=js"
export * from "./order-collection.vue?vue&type=script&lang=js"

import "./order-collection.vue?vue&type=style&index=0&id=3d6cc6cb&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6cc6cb"]])

export default __exports__